import { supabase } from './api'

// Get recognition | activitylistlevelcount
export async function getActivityListLevelCount(studentId) {
	const { data, error } = await supabase.from('activitylistlevelcount').select().eq('studentId', studentId)
	if (error) throw new Error('Failed to fetch activity list level count')
	return data
}

// Get consistency | activitylistgradelevelcount
export async function getActivityListGradeLevelCount(studentId) {
	const { data, error } = await supabase.from('activitylistgradelevelcount').select().eq('studentId', studentId)
	if (error) throw new Error('Failed to fetch activity list level count')
	return data
}

// get impact | activitylistpositioncount
export async function getActivityListPositionCount(studentId) {
	const { data, error } = await supabase.from('activitylistpositioncount').select().eq('studentId', studentId)
	if (error) throw new Error('Failed to fetch activity list position count')
	return data
}

// get commitment | activitylistweeksperyearcount
export async function getActivityListWeeksPerYearCount(studentId) {
	const { data, error } = await supabase.from('activitylistweeksperyearcount').select().eq('studentId', studentId)
	if (error) throw new Error('Failed to fetch activity list weeks per year count')
	return data
}

// get Variety | activitylistcategorycount
export async function getActivityListCategoryCount(studentId) {
	const { data, error } = await supabase.from('activitylistcategorycount').select().eq('studentId', studentId)
	if (error) throw new Error('Failed to fetch activity list weeks per year count')
	return data
}

// Overview – Table: courselessonsdesc
export async function getOverviewTexts(studentId) {
	const { data, error } = await supabase.from('activitylistdesc').select().eq('studentId', studentId)

	if (error) {
		console.error('Supabase error:', error)
		throw new Error('Failed to fetch overview data')
	}

	return data
}

export async function saveOverviewTexts(studentId, overviewMap) {
	for (const [type, desc] of Object.entries(overviewMap)) {
		// Sadece bu type'ı sil
		const deleteRes = await supabase.from('activitylistdesc').delete().eq('studentId', studentId).eq('type', type)

		if (deleteRes.error) {
			console.error(`Error deleting overview for ${type}:`, deleteRes.error.message)
			throw new Error('Failed to delete previous overview data')
		}

		// Yeni overview satırını ekle
		const { error } = await supabase.from('activitylistdesc').insert([{ studentId, type, desc }])

		if (error) {
			console.error(`Error inserting overview for ${type}:`, error.message)
			throw new Error('Failed to insert new overview data')
		}
	}
}
